import React from 'react';
import {
    SkeletonBodyText,
    Page,
    PageActions,
    Card,
    Layout,
    ResourceItem,
    Badge,
    ResourceList,
    Modal,
    TextField
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../../../common/Helpers';
import { Helmet } from 'react-helmet';

class ViewOperationPageOrder extends React.Component {

    constructor(props) {
        super(props);

        const { params } = this.props.match;
        this.state = {
            id: params.id,
            isLoading: true,
            operation: {
            },
            runs: [],
            storeInfo: {},
            renaming: false,
            newName: null
        };
    }

    handleModalClose = () => {
        this.setState({
            newName: null,
            renaming: false
        });
    }

    handleModalRename = () => {
        fetch(`api/operations/tag/${this.state.id}/name`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "id": this.state.id,
                "name": this.state.newName
            })
        }).then(() => {
            var newOperation = this.state.operation;
            newOperation.description = this.state.newName;
            this.setState({
                newName: null,
                renaming: false,
                operation: newOperation
            });
        });
    }

    handleNewNameChange = (value) => {
        this.setState({
            newName: value
        });
    }

    render() {

        var modal = <div>
            <Modal
                open={this.state.renaming}
                onClose={this.handleModalClose}
                title="Rename Operation"
                primaryAction={{
                    content: 'Rename',
                    onAction: this.handleModalRename,
                }}
                secondaryActions={[
                    {
                        content: 'Cancel',
                        onAction: this.handleModalClose,
                    },
                ]}
            >
                <Modal.Section>
                    <TextField
                        value={this.state.newName}
                        onChange={this.handleNewNameChange}
                        autoComplete="off"
                    />
                </Modal.Section>
            </Modal>
        </div>;

        var primary = { content: 'Execute', onAction: () => { this.handleRun(); } };
        var headerSecondary = [
            { content: 'Edit', onAction: this.handleEdit },
            { content: 'Rename', onAction: this.handleRename }
        ];

        if (this.state.operation.isExecuting) {
            primary.isDisabled = true;
        }

        return (

            <div>
                <Helmet>
                    <title>Tag Genie - Edit Operation - {this.state.id}</title>
                </Helmet>
                {this.state.isLoading && <SkeletonBodyText lines="20" />}
                {!this.state.isLoading && <Page
                    title={this.state.operation.description}
                    primaryAction={primary}
                    secondaryActions={headerSecondary}
                    breadcrumbs={[{ content: 'Operations', url: '/operations' }]}
                >
                    <Layout>
                        <Layout.Section>
                            <Card title="Last 10 runs" sectioned primaryFooterAction={primary}>
                                <ResourceList
                                    resourceName={{ singular: 'run', plural: 'runs' }}
                                    items={this.state.runs}
                                    renderItem={this.renderRunItem}
                                />
                            </Card>
                        </Layout.Section>
                    </Layout>
                    {modal}
                    <PageActions
                        secondaryActions={[
                            {
                                content: 'Delete',
                                onAction: this.handleDelete,
                                destructive: true,
                            },
                        ]}
                    />
                </Page>}
            </div>
        );
    }

    handleEdit = () => {
        this.props.history.push(`/operations/order/${this.state.id}/edit`);
    }

    handleDescriptionChange = (newValue) => {
        var operation = this.state.operation;
        operation.description = newValue;
        this.setState({ operation: operation });
    }

    handleDelete = () => {

        fetch(`api/operations/tag/${this.state.id}`, {
            method: 'DELETE'
        }).then(() => {
            this.props.history.push("/operations");
        });
    }

    handleRename = () => {

        this.setState({
            newName: this.state.operation.description,
            renaming: true
        });
    }

    handleRun = () => {

        fetch(`api/operations/tag/${this.state.id}/run`, {
            method: 'POST',
        }).then(() => {
            this.fetchRuns();
        });
    }

    renderRunItem(item) {
        const { id, description, percentDone, runNumber, tagChanges, runTime } = item;
        const dateCreated = new Date(Date.parse(item.dateCreated));

        return (
            <ResourceItem id={id} url={null} onClick={(e) => { }}>
                <div>
                    <div className="operationItemContent">
                        <div className="operationItemContentColumn">
                            <span><b>#{runNumber}</b> - {dateCreated.toLocaleString()} - {tagChanges} tag changes</span>
                        </div>
                        <div className="operationItemContentRight">
                            {percentDone === 100 && <div>
                                <Badge status="success">Completed</Badge>
                            </div>}
                            {percentDone !== 100 && <div>
                                <Badge status="attention">Running - {Math.round(percentDone)}%</Badge>
                            </div>}
                        </div>
                        <div className="operationItemContentRightSmall">
                            {percentDone === 100 && <div>
                                <Badge>{runTime} min.</Badge>
                            </div>}
                        </div>
                    </div>
                    <span className="operationDescription">{description}</span>
                </div>
            </ResourceItem>
        );
    }

    componentDidMount() {
        fetch(`api/operations/tag/${this.state.id}/status`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {

                this.setState({
                    operation: data,
                    isLoading: false
                });
            });

        this.fetchRuns();
        // this.getStoreInfo();
    }

    fetchRuns = () => {
        fetch(`api/operations/tag/${this.state.id}/runs`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                runs: data
            }));
    }
}

export default ViewOperationPageOrder;